import RegisterForm from "@/model/Form/RegisterForm"
import registerForm from "@/state/registerForm"
import email from "@/state/email"
import isSubscribeNewsletter from "@/state/isSubscribeNewsletter"
import { defaultCdaConsent } from "@/types/CdaConsent"

const resetRegisterForm = async () => {
    const newRegisterForm: RegisterForm = new RegisterForm(email.value)
    registerForm.value = newRegisterForm
    isSubscribeNewsletter.value = defaultCdaConsent()
}

export default resetRegisterForm
